import React from 'react';
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from '../Home/HomeNav.jsx';
import HomeFooter from '../Home/HomeFooter.jsx';
import HomePricingPlans from '../Home/HomePricingPlans.jsx';
import EventPricingCalculator from './EventPricingCalculator.jsx';
import PricingPageIntro from './PricingPageIntro.jsx';
import CompanyCarousel from './CompanyCarousel.jsx';
import PricingBottomCta from './PricingBottomCta.jsx';
const Pricing = () => {
  return <div className='font-figtree' data-sentry-component="Pricing" data-sentry-source-file="Pricing.jsx">
      <NextSeo {...seoFunct("pricingSeo")} data-sentry-element="NextSeo" data-sentry-source-file="Pricing.jsx" />
      <HomeNav isBgNavyBlue={false} data-sentry-element="HomeNav" data-sentry-source-file="Pricing.jsx" />
      <PricingPageIntro data-sentry-element="PricingPageIntro" data-sentry-source-file="Pricing.jsx" />
      <HomePricingPlans ishomePage={'pricing-page'} data-sentry-element="HomePricingPlans" data-sentry-source-file="Pricing.jsx" />
      {/* <EventPricingCalculator /> */}
      <CompanyCarousel isPricingPage={true} data-sentry-element="CompanyCarousel" data-sentry-source-file="Pricing.jsx" />
      <PricingBottomCta data-sentry-element="PricingBottomCta" data-sentry-source-file="Pricing.jsx" />
      <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="Pricing.jsx" />
    </div>;
};
export default withRouter(Pricing);